/**
 * Constants
 * */
export const moduleName = `breadcrumbs`;

/**
 * Reducer
 * */

export default function reducer(state = [], action) {
  const {type} = action;

  switch (type) {
    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const breadcrumbsSelector = (state) => state[moduleName];

/**
 * Action Creators
 * */
